/**
 * Legacy module — preserved empty so `acme.common.service.posConfigNavigation`
 * keeps resolving. Real impl (internal sub-service of PosConfigService, not
 * downgrade-registered):
 *   apps/b2b-frontend/app/core/pos-config/navigation/pos-config-navigation.service.ts
 * Wave 3 item #17.
 */
angular.module('acme.common.service.posConfigNavigation', []);
